import { Component, Input } from '@angular/core';
import {
  CadastroContratoDto,
  MaritalStatus,
  MeioPagamento,
  OwnerDto,
  ProjetoTipo,
  PropertyDto,
  PropertyUsage,
  ReurbModalidade
} from '@usucampeao/lib-reurb-simplificado';
import { NumeroExtensoTipo } from '@usucampeao/utils';

@Component({
  selector: 'usucampeao-somente-averbacao-v3',
  templateUrl: './somente-averbacao-v3.component.html',
  styleUrls: ['./somente-averbacao-v3.component.scss']
})
export class SomenteAverbacaoV3Component {
  @Input() cadastro!: CadastroContratoDto;
  @Input() proprietario!: Partial<OwnerDto>;
  @Input() conjuge!: Partial<OwnerDto>;
  @Input() imovel!: Partial<PropertyDto>;
  @Input() isPrint: boolean;

  public get imovelTipo(): typeof PropertyUsage {
    return PropertyUsage;
  }

  public get meioPagamento(): typeof MeioPagamento {
    return MeioPagamento;
  }

  public get numeroExtensoTipo(): typeof NumeroExtensoTipo {
    return NumeroExtensoTipo;
  }

  public get reurbModalidade(): typeof ReurbModalidade {
    return ReurbModalidade;
  }

  public get estadoCivil(): typeof MaritalStatus {
    return MaritalStatus;
  }

  public get projetoTipo(): typeof ProjetoTipo {
    return ProjetoTipo;
  }

  public get pagamentoAVista(): boolean {
    return !this.cadastro?.totalParcelas || this.cadastro.totalParcelas === 0;
  }

  public get possuiAverbacao(): boolean {
    return this.cadastro?.averbacao;
  }

  public get isPagamentoAVista(): boolean {
    return this.cadastro.pagamentos.length === 1;
  }
}
